import { render, staticRenderFns } from "./NewFormulaModal.vue?vue&type=template&id=51376f3a&scoped=true&"
import script from "./NewFormulaModal.vue?vue&type=script&lang=js&"
export * from "./NewFormulaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51376f3a",
  null
  
)

export default component.exports